// src/components/TopBar.js
import React from 'react';
import axios, { clearAuth } from '../utils/axiosInstance';
import '../App.css';
import logo from '../assets/rankr_logo.svg'; // <-- NEW

const TopBar = () => {
  const handleLogout = async () => {
    try { await axios.post('/auth/logout'); } catch (_) {}
    try {
      localStorage.removeItem('token');
      localStorage.removeItem('username');
      localStorage.removeItem('isAdmin');
      sessionStorage.clear();
    } catch (_) {}
    try { clearAuth(); } catch (_) {}
    window.location.replace('/auth');
  };

  return (
    <header className="topbar">
      <div className="brand" aria-label="Rankr">
        <img src={logo} className="brand-logo" alt="" aria-hidden="true" />
        <span className="brand-text">rankr</span>
      </div>
      <button className="logout-btn" onClick={handleLogout}>Log out</button>
    </header>
  );
};

export default TopBar;
